export var OnboardingStatus;
(function (OnboardingStatus) {
    OnboardingStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    /** On first get or create */
    OnboardingStatus["INITIALIZING"] = "INITIALIZING";
    /** When all the steps are initialized */
    OnboardingStatus["READY"] = "READY";
    /** When all steps are Completed or Skipped */
    OnboardingStatus["COMPLETED"] = "COMPLETED";
})(OnboardingStatus || (OnboardingStatus = {}));
export var StepKey;
(function (StepKey) {
    StepKey["UNKNOWN_STEP_KEY"] = "UNKNOWN_STEP_KEY";
    StepKey["CREATE_POST"] = "CREATE_POST";
    StepKey["UPDATE_DESCRIPTION"] = "UPDATE_DESCRIPTION";
    StepKey["EXPLORE_DASHBOARD"] = "EXPLORE_DASHBOARD";
    StepKey["REACT_TO_POST"] = "REACT_TO_POST";
    StepKey["INVITE_MEMBERS"] = "INVITE_MEMBERS";
    StepKey["UPDATE_COVER_IMAGE"] = "UPDATE_COVER_IMAGE";
})(StepKey || (StepKey = {}));
export var Status;
(function (Status) {
    Status["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    Status["ACTIVE"] = "ACTIVE";
    Status["SKIPPED"] = "SKIPPED";
    Status["COMPLETED"] = "COMPLETED";
})(Status || (Status = {}));
export var Platform;
(function (Platform) {
    Platform["UNKNOWN_PLATFORM"] = "UNKNOWN_PLATFORM";
    Platform["ALL"] = "ALL";
    Platform["MOBILE"] = "MOBILE";
    Platform["WEB"] = "WEB";
})(Platform || (Platform = {}));
export var ApplicationType;
(function (ApplicationType) {
    ApplicationType["UNKNOWN_APP_TYPE"] = "UNKNOWN_APP_TYPE";
    ApplicationType["ALL_TYPES"] = "ALL_TYPES";
    ApplicationType["DASHBOARD"] = "DASHBOARD";
    ApplicationType["LIVE_SITE"] = "LIVE_SITE";
})(ApplicationType || (ApplicationType = {}));
export var Role;
(function (Role) {
    Role["UNKNOWN"] = "UNKNOWN";
    Role["ADMIN"] = "ADMIN";
    Role["MEMBER"] = "MEMBER";
})(Role || (Role = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map